import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '../../../core/auth.service';
import { JobAccessService } from '../../../core/job-access.service';

/** docs/design/37 section 2.2 - the roles of the management dashboard (the API refuses everyone else). */
export const MANAGEMENT_DASHBOARD_ROLES = ['SystemAdmin', 'FacilityManager'] as const;

/**
 * The /dashboard route shows the management dashboard to SystemAdmin and FacilityManager of an organization that owns properties; every other role, and the
 * users of a service-provider organization (which the API refuses), fall through to the route below it: the tile page they have today.
 */
export const managementDashboardMatch: CanMatchFn = () => {
  const auth = inject(AuthService);
  return !auth.isProviderOrganization() && MANAGEMENT_DASHBOARD_ROLES.some((role) => auth.hasRole(role));
};

/**
 * docs/design/42 - /dashboard shows the provider dashboard to whoever runs a service provider's jobs: a member of a service-provider organization for whom `JobAccessService.canRunJobs` holds (its
 * administrator, or - while it has no active administrator - a technician; asked of the server once). Everyone else falls through to the management dashboard or the tile page.
 */
export const providerDashboardMatch: CanMatchFn = () => {
  const auth = inject(AuthService);
  return auth.isProviderOrganization() ? inject(JobAccessService).load() : false;
};
